import React from 'react';
import createCtx from 'coreUtils/createCtx';

export const [useHeaderCtx, HeaderProvider] = createCtx<{
	isInHeaderContext: boolean;
	handleNavigationItemClick: (id: string, parentId: string) => (event: React.SyntheticEvent) => void;
	handleNavigationVisibility: () => void;
	handleNavigationGoBack: () => void;
}>();